import { UNIT_TYPES } from 'constants'

export const sortBattleModeSettings = battleModesSettings => [...battleModesSettings].sort((a, b) => {
    if (a.unit_type === b.unit_type) return a.max_vehicle_level - b.max_vehicle_level

    return [UNIT_TYPES.SORTIE, UNIT_TYPES.FORT_BATTLE].indexOf(a.unit_type)
})



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/BattleModeFilter/helpers.js